import React, { useEffect, useRef, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useLocation } from 'react-router-dom'
import { PageLoader } from '@/components/ui/PageLoader'

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, loginWithRedirect, error } = useAuth0()
  const location = useLocation()
  const redirectStarted = useRef(false)
  const [redirectFailed, setRedirectFailed] = useState(false)

  useEffect(() => {
    if (isAuthenticated) redirectStarted.current = false
    if (isLoading || isAuthenticated || error || redirectStarted.current) return
    redirectStarted.current = true
    loginWithRedirect({ appState: { returnTo: location.pathname + location.search } }).catch(() =>
      setRedirectFailed(true),
    )
  }, [isAuthenticated, isLoading, loginWithRedirect, error, location.pathname, location.search])

  if (error || redirectFailed)
    return (
      <div className='p-5 text-center' role='alert'>
        <h2>Sign-in could not be completed</h2>
        <p>Your account data has not been loaded. Reload to try again.</p>
        <button type='button' className='btn btn-primary' onClick={() => window.location.reload()}>
          Try again
        </button>
      </div>
    )
  if (isLoading || !isAuthenticated) return <PageLoader />
  return <>{children}</>
}
